<template>
  <b-modal
    id="map-settings-dialog"
    ref="modal"
    :title="$t('dispatch_system.map_settings_title')"
    :ok-disabled="isProcessing"
    size="sm"
    centered
    no-close-on-backdrop
    @shown="onShow"
    @ok="onOk">
    <form ref="form" @submit="save">
      <fields :model="model" :errors="errors" ungrouped layout="vertical" />
    </form>
  </b-modal>
</template>

<script>
import Api from './Api'
import { ResourceFormMixin } from 'stylemix-vue-admin'

export default {
  name: 'MapSettingsFormModal',

  mixins: [ResourceFormMixin],

  data() {
    return {
      isProcessing: false,
    }
  },

  methods: {
    api() {
      return new Api()
    },
    onOk(event) {
      this.isProcessing = true
      event.preventDefault()
      this.api().save(this.model)
        .then(result => {
          this.$bvModal.hide('map-settings-dialog')
          this.$toast.success(result.message)
          this.$emit('saved', result.settings)
        })
        .finally(() => {
          this.isProcessing = false
        })
    },
    onShow() {
      this.isProcessing = true
      this.api().getSettings().then(data => {
        this.isProcessing = false;
        this.model = data.data
        this.groups = data.groups
        this.setFields(data.fields)
      })
    },
  },
}
</script>
<style>
.pac-container {
  z-index: 10000;
}
</style>
